import React, { useState } from "react";

const ToggleButton = (props) => {
    const { enabled, onChange } = props;

    return (
        <div className="">
            <div className="relative cursor-pointer">
                <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={enabled}
                    readOnly
                />
                <div
                    onClick={() => {
                        onChange(!enabled);
                    }}
                    className={`w-8 h-[18px] bg-white rounded-full border border-black-10 peer-checked:border-orange-color peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-2/4 after:-translate-y-2/4 after:left-[2px] after:bg-black-10 after:rounded-full after:h-3.5 after:w-3.5 after:transition-all peer-checked:after:bg-orange-color`}
                ></div>
            </div>
        </div>
    );
};

export default ToggleButton;
